<template>
  <v-card flat>
    <div ref="chart"></div>
    <!-- <span>
        {txt}
        </span> -->
  </v-card>
</template>
<script>
import * as d3 from "d3";
import { mapGetters } from "vuex";
export default {
  name: "dailyPieChart",
  data() {
    return {
      //
    };
  },
  computed: {
    ...mapGetters([
      "kioskAnalytics",
      "pieChart",
      "getPieChartTotal",
      "kioskAnalyticsDimension",
      "windowSize",
    ]),
  },
  watch: {
    kioskAnalytics(newVal) {
      this.createPieChart();
    },
    windowSize(newVal) {
      this.createPieChart();
    },
  },
  methods: {
    createPieChart() {
      d3.select(this.$refs.chart).select("svg").remove();
      const width = this.kioskAnalyticsDimension.pieChartDimension.width + 400;
      const height = this.kioskAnalyticsDimension.pieChartDimension.height;
      const legendSpacing = 30; // Space between legend items
      //const radius = Math.min(width, height) / 2.2;
      let pieChartVal = this.pieChart;
      console.log(height, width, "this are height and width.");
      const svg = d3
        .select(this.$refs.chart)
        .append("svg")
        .attr("width", width - 100)
        .attr("height", height - 100)
        .attr("viewBox", [-width / 2, -height / 2, width, height])
        .attr(
          "transform",
          "translate(-75, 0)" // Shift the entire chart and legends by 75 pixels
        )
        .attr("style", "max-width: 100%; height: auto; font: 10px sans-serif;");

      const color = d3
        .scaleOrdinal()
        .domain(pieChartVal.map((d) => d.label))
        .range(
          d3
            .quantize(
              (t) => d3.interpolateSpectral(t * 0.8 + 0.1),
              pieChartVal.length
            )
            .reverse()
        );

      const arc = d3
        .arc()
        .outerRadius(Math.min(width, height) / 2 - 1)
        .innerRadius(0);

      const labelRadius = arc.outerRadius()() * 0.8;

      // const arcLabel = d3.arc()
      //     .innerRadius(labelRadius)
      //     .outerRadius(labelRadius);

      const arcLabel = d3
        .arc()
        .innerRadius((Math.min(width - 200, height) / 2) * 0.8)
        .outerRadius((Math.min(width - 200, height) / 2) * 0.8);

      // const arcLabel = d3.arc()
      //     .innerRadius(Math.min(400, 400) / 2 * 0.8) // Move labels outward
      //     .outerRadius(Math.min(400, 400) / 2 * 0.8);

      // .padAngle(0.020)
      const pie = d3
        .pie()
        .padAngle(0.02)
        .value((d) => d.value);

      if (pieChartVal.every((item) => item.value === 0)) {
        svg
          .append("text")
          .attr("text-anchor", "middle")
          .attr("dy", "0.3em")
          .text("No data available");
      } else {
        pieChartVal.forEach((d) => {
          d.percentage = (d.value / this.getPieChartTotal) * 100;
        });

        pieChartVal = pieChartVal.filter((d) => d.value > 0);

        const arcs = pie(pieChartVal);

        svg
          .append("g")
          .attr("stroke", "white")
          .selectAll()
          .data(arcs)
          .join("path")
          .attr("fill", (d) => color(d.data.label))
          .attr("d", arc)
          .append("title")
          .text((d) => `${d.data.label}: ${d.data.value}`);

        svg
          .append("g")
          .attr("text-anchor", "middle")
          .selectAll()
          .data(arcs)
          .join("text")
          .attr("transform", (d) => `translate(${arcLabel.centroid(d)})`)
          // .call(text => text.append("tspan")
          //     .attr("x", "-0.6px")
          //     .attr("y", "-0.8px")
          //     .attr("font-weight", "bold")
          //     .attr("font-size", '12px')
          //     .text(d => d.data.label)
          //     )
          .call((text) =>
            text
              .filter((d) => d.endAngle - d.startAngle > 0.01)
              .append("tspan")
              .attr("x", 0)
              .attr("y", "10px")
              .attr("font-weight", "bold")
              .attr("fill-opacity", 0.7)
              .text((d) => `${d.data.value}`)
          );

        // Adding Legends
        // Adding Legends
        const legend = svg
          .append("g")
          .attr(
            "transform",
            `translate(${Math.min(width, height) / 2 + 75}, ${
              (-pieChartVal.length * legendSpacing) / 2
            })`
          ) // Move legends to the right and center vertically
          .selectAll("g")
          .data(pieChartVal.filter((d) => d.value > 0))
          .join("g")
          .attr("transform", (d, i) => `translate(0, ${i * legendSpacing})`);

        legend
          .append("rect")
          .attr("width", 20)
          .attr("height", 20)
          .attr("fill", (d) => color(d.label));

        legend
          .append("text")
          .attr("x", 30) // Add space between rectangle and text
          .attr("y", 14) // Align text vertically with the rectangle
          .style("font-size", "20px")
          .style("font-weight", "bold")
          .text((d) => d.label);
      }
      return svg.node();
    },
  },
};
</script>
